import type { AxiosError } from 'axios'
import type { GraphQLFormattedError } from 'graphql'

export type ShowError = (err: GraphQLFormattedError | AxiosError | Error) => void

let showErrorImpl: ShowError | null = null

/**
 * Registered by `ErrorProvider` as it constructs. Kept as a separate module so callers
 * that only need to *report* an error can do so without importing `ErrorProvider`,
 * which pulls in `graphql` and `@acre/graphql` and so cannot be reached from the
 * apollo-free `@acre/utils/core` entry.
 */
export const registerShowError = (impl: ShowError) => {
  showErrorImpl = impl
}

/** No-op until an `ErrorProvider` has mounted, rather than throwing. */
export const showError: ShowError = (err) => showErrorImpl?.(err)
